$(document).ready(function () {
    initHeaderSticky()
  });
  $(window).resize(function() {
    initHeaderSticky()
  });
  $(window).scroll(function() {
    initHeaderSticky()
  });
  function initHeaderSticky() {
    if (jQuery(document).height() > jQuery(window).height()) {
        if (jQuery('.site-header .main-navigationbar').hasClass("sticky_header")) {
          if (jQuery(this).scrollTop() > 400) {
            jQuery('.site-header .main-navigationbar').addClass("fixed");
          } else {
            jQuery('.site-header .main-navigationbar').removeClass("fixed");
          }
        } else {
          jQuery('.site-header .main-navigationbar').removeClass("fixed");
        }
    }
  }
$(document).ready(function() {
      jQuery(".product-write-review").on('click',function(e) {
        $(".product-review").toggleClass("open-model");
        $('body').addClass('no-scroll open');
        $('.overlay').addClass('active');
      });
      jQuery(".overlay,.review-close-icon").on('click',function(e) {
        $(".product-review").removeClass("open-model");
        $('body').removeClass('no-scroll open');
        $('.overlay').removeClass('active');
      });
    jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<div class="container"><div class="row"></div></div>');
    jQuery('.carthead').prependTo('.template-cart .wrapper > .container > .row');
      countDownIni('.flip-countdown,.js-flip-countdown');
    /********* desktop menu *********/
  $(".menu-lnk.has-item").hover(function(){
     $(this).toggleClass("menu_active");
    $(this).find(".menu-dropdown").toggleClass("open_menu");
    $("body").toggleClass("no-scroll");
  });
        /********* On scroll heder Sticky *********/
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function () {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos) {
            document.getElementById("header-sticky").style.top = "0";
          } else {
            document.getElementById("header-sticky").style.top = "-200px";
          }
          prevScrollpos = currentScrollPos;
        }
        //video-play 
        $('.play-vid').on('click',function(){
            if($(this).attr('data-click') == 1) {
            $(this).attr('data-click', 0)
            $('#img-vid')[0].pause();
            $(".play-vid").css("opacity", "1");
            } else {
            $(this).attr('data-click', 1)
            $('#img-vid')[0].play();
            $(".play-vid").css("opacity", "1");
            $(".play-vid").css("opacity", "0");
            }
        }); 
        $('.play-btn').click(function (m) { 
            $('body,html').addClass('no-scroll popupopen');
            $('.overlay-popup').addClass('popup-show');
        });  
        $('.close-popup').click(function (m) { 
            $('body,html').removeClass('no-scroll popupopen');  
            $('.overlay-popup').removeClass('popup-show');
        }); 
        /********* Mobile Menu ********/  
         $("#menu").on("click", function () {
        $(".mobile-menu-wrapper, body").toggleClass("active-menu");
      });
      $(".menu-close-icon svg").on("click", function () {
        $(".mobile-menu-wrapper, body").toggleClass("active-menu");
      });
        $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
            $('body').removeClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").removeClass("active-menu");
            $('.overlay').removeClass('menu-overlay');
        });
        /*********  size Popup  ********/ 
        $(".size-btn").click(function() { 
            $(".size-popup").toggleClass("active"); 
            $("body").toggleClass("no-scroll");
        });
        $(".close-search").click(function() { 
            $(".size-popup").removeClass("active"); 
            $("body").removeClass("no-scroll");
        });
        $(".close-btn").click(function() { 
            $(".size-popup").removeClass("active"); 
            $("body").removeClass("no-scroll");
        });
        /********* Cart Popup ********/
         $('.main-cart').on('click', function (e) {
                $('body').addClass('no-scroll cartOpen');
                //$('.overlay').addClass('cart-overlay');
        });
        $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
            //$('.overlay').removeClass('cart-overlay');
            $('body').removeClass('no-scroll cartOpen');
        }); 
          $(document).on('click', '.hmuser', function(e) {
              $(this).toggleClass('active');
              $(this).next().slideToggle('fast');
              $(".dropdown-menu").not($(this).next()).slideUp('fast');
          });
        /********* Mobile Filter Popup ********/
                $('.mobile-facets__open').on('click', function (e) {
            $('body').addClass('mobile-open no-scroll');
          $('.overlay').addClass('active');
    });
        $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
            $('body').removeClass('mobile-open no-scroll');
          $('.overlay').removeClass('active');
    });
    $('.filter-title').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll filter-open');
            $('.overlay').addClass('active');
        }, 50);
    }); 
    $('body').on('click','.overlay.active, .close-filter', function(e){
        e.preventDefault(); 
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll filter-open');
    }); 
        /*********  Header Search Popup  ********/ 
        $(".search-header a").click(function() { 
            $(".search-popup").toggleClass("active"); 
            $("body").toggleClass("no-scroll");
        });
        $(".close-search").click(function() { 
            $(".search-popup").removeClass("active"); 
            $("body").removeClass("no-scroll");
        });
        /******* Cookie Js *******/
        $('.cookie-close').click(function () {
            $('.cookie').slideUp();
        });
        /******* Subscribe popup Js *******/
        $('.close-sub-btn').click(function () {
            $('.subscribe-popup').slideUp(); 
            $(".subscribe-overlay").removeClass("open");
        });      
        /********* qty spinner ********/
        var quantity = 0;
        $('.quantity-increment').click(function(){;
            var t = $(this).siblings('.quantity');
            var quantity = parseInt($(t).val());
            $(t).val(quantity + 1); 
        }); 
        $('.quantity-decrement').click(function(){
            var t = $(this).siblings('.quantity');
            var quantity = parseInt($(t).val());
            if(quantity > 1){
                $(t).val(quantity - 1);
            }
        });
        /*********  Multi-level accordion nav  ********/ 
        $('.acnav-label').click(function () {
            var label = $(this);
            var parent = label.parent('.has-children');
            var list = label.siblings('.acnav-list');
            if (parent.hasClass('is-open')) {
                list.slideUp('fast');
                parent.removeClass('is-open');
            }
            else {
                list.slideDown('fast');
                parent.addClass('is-open');
            }
        });  
        /****  TAB Js ****/
        $('ul.tabs li').click(function(){
            var $this = $(this);
            var $theTab = $(this).attr('data-tab');
            if($this.hasClass('active')){
              // do nothing
            } else{
              $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
              $('.tabs-container .tab-content[id="'+$theTab+'"], ul.tabs li[data-tab="'+$theTab+'"]').addClass('active');
            }
            $('.bestseller-slider').slick('refresh');
            $('.testimonial-slider').slick('refresh');
        });    
        // HOME PAGE SLIDER //

        $(document).ready(function () {
            var $slider = $('.home-banner-slider');
            var $progressBar = $('.progress');
            var $progressBarLabel = $('.slider__label');
    
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
    
                $progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
    
                $progressBarLabel.text(calc + '% completed');
            });
    
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
            });
        });
        var $slider = $('.home-banner-slider');
        if ($slider.length) {
            var currentSlide;
            var slidesCount;
            var sliderCounter = document.createElement('div');
            sliderCounter.classList.add('slider__counter');
    
            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;
                $(sliderCounter).text(currentSlide + '-' + slidesCount)
            };
    
            $slider.on('init', function (event, slick) {
                $slider.append(sliderCounter);
                updateSliderCounter(slick);
            });
    
            $slider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });
        }
        var $status = $('.pagingInfo');
        var $slickElement = $('.slideshow');
    
        // $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //     //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        //     var i = (currentSlide ? currentSlide : 0) + 1;
        //     $status.text(i + '/' + slick.slideCount);
        // });
        $slickElement.slick({
            slide: '.slide-placeholder',
            autoplay: true,
            dots: true
        });


        if($('.partner-slider').length > 0 ){
            $('.partner-slider').slick({
                autoplay: true, 
                slidesToShow: 5,
                speed: 1000,
                slidesToScroll: 1,  
                centerMode: true,
                centerPadding: 0,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                dots: false,
                buttons: true,
                responsive: [  
                    {
                        breakpoint:992,
                            settings: {
                                slidesToShow:3,
                                slidesToScroll: 2 
                            }
                        } ,
                    {
                        breakpoint: 576,
                        settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1   
                        }
                    } ,
                    {
                        breakpoint: 421,
                        settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1   
                        }
                    }
                ]
            });
        }

        if($('.bestseller-slider').length > 0 ){
            $('.bestseller-slider').slick({
                autoplay: false, 
                slidesToShow: 4,
                speed: 1000,
                slidesToScroll: 1,   
                arrows:true,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                dots: false,
                buttons: false,
                responsive: [  
                    {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint:768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    } ,
                    {
                    breakpoint:576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    },
                ]
            });
        } 

        if($('.reiview-slider').length > 0 ){
            $('.reiview-slider').slick({
                autoplay: false, 
                slidesToShow: 2,
                speed: 1000,
                slidesToScroll: 1,   
                arrows:false,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                dots: true,
                buttons: false,
                responsive: [  
                    {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint:768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    } ,
                    {
                    breakpoint:576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    },
                ]
            });
        }

        if($('.bestpro-slider').length > 0 ){
            $('.bestpro-slider').slick({
                autoplay: true, 
                slidesToShow: 4,
                speed: 1000,
                slidesToScroll: 3,  
                centerMode: true,
                centerPadding: 0,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                dots: false,
                buttons: true,
                responsive: [  
                    {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint:768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    } ,
                    {
                    breakpoint:576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    },
                ]
            });
        }

        if($('.blog-slider').length > 0 ){
            $('.blog-slider').slick({
                autoplay: false, 
                slidesToShow: 4,
                speed: 1000,
                slidesToScroll: 1,  
                prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
                dots: false,
                buttons: false,
                responsive: [ 
                    {
                        breakpoint: 1400,
                        settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1   
                        }
                    },
                    {
                    breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                    {
                    breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    }
                ]
            });
        }

        // PDP SLIDER //

        $(document).ready(function () {
            $('.pdp-main-slider').slick({
                dots: false,
                infinite: true,
                speed: 500,
                loop: true,
                slidesToShow: 1,
                arrows: false,
                asNavFor: '.pdp-thumb-slider',
            });
            var $slider = $('.pdp-thumb-slider');
            var $progressBar = $('.progress');
            var $progressBarLabel = $('.slider__label');
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
                // $(calc).css('height','10px')
                if ($slider.length) {
                    var currentSlide;
                    var slidesCount;
                    var sliderCounter = document.createElement('div');
                    sliderCounter.classList.add('slider__label');
                    var updateSliderCounter = function (slick, currentIndex) {
                        currentSlide = slick.slickCurrentSlide() + 1;
                        slidesCount = slick.slideCount;
                        $(sliderCounter).text(currentSlide + '-' + slidesCount)
                    };
                    $slider.on('init', function (event, slick) {
                        $slider.append(sliderCounter);
                        updateSliderCounter(slick);
                    });
                    $slider.on('afterChange', function (event, slick, currentSlide) {
                        updateSliderCounter(slick, currentSlide);
                    });
                }
                $progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc)
                // .css('height','5px');
                $progressBarLabel.text(calc + '% completed');
            });
            });
            var $status = $('.pagingInfo-pdp');
            var $slickElement = $('.pdp-thumb-slider');
            
            $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '-' + slick.slideCount);
            });
        
        $slickElement.slick({
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            dots: false,
            asNavFor: '.pdp-main-slider', 
            speed: 500, 
            slidesToScroll: 1,
            touchMove: true,
            focusOnSelect: true,
            loop: true,
            arrows: false,
            infinite: true,
            focusOnSelect: true,
            slidesToShow: 4,
            responsive: [{
                    breakpoint: 475,
                    settings: {
                        slidesToShow: 2 
                    }
                } 
            ] 
        });

          // Slick lightbox 
      if ($('.lightbox').length > 0) {
        $('.lightbox').slickLightbox({
          itemSelector: 'a.open-lightbox',
          caption: 'caption',
          prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
          navigateByKeyboard: true,
          layouts: {
            closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
          }
        });
      }

        // currency
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

        // coupan code
  $('body').on('keyup','.discount_coupan', function() {
   var apply_href = $('.apply').attr("href").split('discount=')[0];
   var val = $(this).val();
    $('.apply').attr("href",apply_href+'discount='+val);
  });

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
  

// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.nice-select.qv_select__select', function() {
    var selectedValues = [];

    // Collect selected option values
    $('.nice-select.qv_select__select').each(function() {
      var selectedValue = $(this).val();
      if (selectedValue) {
        selectedValues.push(selectedValue);
      }
    });
    var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
          $('#quick-view-temp .quantity-select').show();
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
          $('#quick-view-temp .quantity-select').hide();
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview

     // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-left-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#ffffff' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  });
  
    });  
    
    if ($(".my-acc-column").length > 0) {
        jQuery(function ($) {
            var topMenuHeight = $("#daccount-nav").outerHeight();
            $("#account-nav").menuScroll(topMenuHeight);
            $(".account-list li:first-child").addClass("active");
        });
        // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
        jQuery.fn.extend({
            menuScroll: function (offset) {
                // Declare all global variables
                var topMenu = this;
                var topOffset = offset ? offset : 0;
                var menuItems = $(topMenu).find("a");
                var lastId;
                // Save all menu items into scrollItems array
                var scrollItems = $(menuItems).map(function () {
                    var item = $($(this).attr("href"));
                    if (item.length) {
                        return item;
                    }
                });
                // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
                $(topMenu).on("click", "a", function (e) {
                    var href = $(this).attr("href");
                    var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
                    function checkWidth() {
                        var windowSize = $(window).width();
                        if (windowSize <= 767) {
                            $('html, body').stop().animate({
                                scrollTop: offsetTop - 200
                            }, 300);
                        }
                        else {
                            $('html, body').stop().animate({
                                scrollTop: offsetTop - 100
                            }, 300);
                        }
                    }
                    // Execute on load
                    checkWidth();
                    // Bind event listener
                    $(window).resize(checkWidth);
                    e.preventDefault();
                });
                // When page is scrolled
                $(window).scroll(function () {
                    function checkWidth() {
                        var windowSize = $(window).width();
                        if (windowSize <= 767) {
                            var nm = $("html").scrollTop();
                            var nw = $("body").scrollTop();
                            var fromTop = (nm > nw ? nm : nw) + topOffset;
                            // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                            var current = $(scrollItems).map(function () {
                                if ($(this).offset().top - 250 <= fromTop)
                                    return this;
                            });
                            // Get the most recent passed section from current array
                            current = current[current.length - 1];
                            var id = current && current.length ? current[0].id : "";
                            if (lastId !== id) {
                                lastId = id;
                                // Set/remove active class
                                $(menuItems)
                                    .parent().removeClass("active")
                                    .end().filter("[href='#" + id + "']").parent().addClass("active");
                            }
                        }
                        else {
                            var nm = $("html").scrollTop();
                            var nw = $("body").scrollTop();
                            var fromTop = (nm > nw ? nm : nw) + topOffset;
                            // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                            var current = $(scrollItems).map(function () {
                                if ($(this).offset().top <= fromTop)
                                    return this;
                            });
                            // Get the most recent passed section from current array
                            current = current[current.length - 1];
                            var id = current && current.length ? current[0].id : "";
                            if (lastId !== id) {
                                lastId = id;
                                // Set/remove active class
                                $(menuItems)
                                    .parent().removeClass("active")
                                    .end().filter("[href='#" + id + "']").parent().addClass("active");
                            }
                        }
                    }
                    // Execute on load
                    checkWidth();
                    // Bind event listener
                    $(window).resize(checkWidth);
                });
            }
        });
    }
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});

jQuery(window).resize(function() {
  responsiveMenu();
});

/******  STEPPY FORM  CSS  ******/
var totalSteps = $(".steps li").length;
$(".submit").on("click", function(){
  return false; 
});

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active"); 
  $('.right-slider').slick('refresh');  
});

$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
  $('.right-slider').slick('refresh');
}); 
/******  STEPPY FORM  CSS  End******/
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }

  });
}